<script lang="ts">
	export let message = '';
	export let center = false;
</script>

<div
	class="text-red-400 font-semibold"
	class:text-center={center}>
	{message}
</div>